module.exports = __webpack_public_path__ + "img/login-bg.0e93bc9a.png";